<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">Top 10 Colleges</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36" height="36" style="margin-left:0.5em;" src="assets/tenant-avatar.jpg" class="rounded-circle" />
          </div>
        </div>

        <!-- Search + Add on same line -->
        <div class="row my-4 align-items-center">
          <div class="col-md-7 col-lg-8">
            <div class="search-wrapper">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>

              <input
                type="text"
                class="search-input"
                placeholder="Search college name, material or description..."
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
                aria-label="Search"
              />

              <button *ngIf="searchval" class="clear-btn" type="button" (click)="reset()" aria-label="Clear search">
                ✕
              </button>
            </div>
          </div>

          <div class="col-md-5 col-lg-4 text-right">
            <button type="button" class="btn btn-primary add-btn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add Colleges
            </button>
          </div>
        </div>

        <!-- Content blocks -->
        <div *ngIf="showData">
          <div class="displayImages" *ngFor="let image of allCollegeImages; let indexOfelement = index;">
            <div class="row align-items-center mb-3">
              <div class="col-md-3">
                <h5 class="mb-0">{{ image.college_name }}</h5>
              </div>

              <div class="col-md-9 text-right">
                <button class="btn btn-outline-primary action-btn" (click)="viewImages(indexOfelement)">View All</button>
                <button class="btn btn-outline-success action-btn" (click)="openAdd1(indexOfelement, image)">Add Images</button>
                <button class="btn btn-outline-danger action-btn" (click)="deleteallimage(indexOfelement)">Delete All</button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 mb-3" *ngFor="let img of image.lessData">
                <div class="img-wraps">
                  <img class="clgImg rounded shadow-sm" [src]="img.images" alt="college image" />
                  <i class="fa fa-trash-o closes delete-icon" aria-hidden="true" (click)="deleteImage(img.image_id)"></i>
                </div>
              </div>
            </div>
            <hr class="mb-4" />
          </div>
        </div>

        <div class="noData text-center py-5" *ngIf="showNodata">
          <h4>Currently No Data Available!</h4>
        </div>

      </div>

      <!-- Add Colleges Modal -->
      <div class="backdrop" [ngStyle]="{'display':display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add Colleges
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="courseForm">
                <label>College Name</label>
                <input type="text" class="form-control" formControlName="collegeval" [(ngModel)]="document" />

                <label class="uploadlogo">Upload logo
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input type="file" formControlName="colglogoImg" (change)="handleFileInputlogo($event)" multiple />
                </label>

                <label class="uploadImage">Upload College Images
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple />
                </label>

                <div class="error-messages">
                  <div *ngFor="let error of error_messages.collegeval">
                    <div class="error-message" *ngIf="courseForm.get('collegeval').hasError(error.type) && (courseForm.get('collegeval').dirty || courseForm.get('collegeval').touched)">
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <div class="addBtn" *ngIf="showAdd">
                  <button class="commonBtn mt-2" (click)="addtopcImages()">Add Colleges</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Images Modal -->
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayimages}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add Images
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandledimage()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <label class="uploadImage">Upload Image
                <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple />
              </label>

              <div class="mb-3">
                <img class="multipleImg mr-2" width="80" height="80" *ngFor="let img of images" [src]="img" />
              </div>

              <div class="addBtn" *ngIf="showAdd">
                <button class="commonBtn mt-2" (click)="topcollegeImage()">Add Images</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
